import React from "react";
import { StatusAlert } from "@/components/auth";
import { withAppBase } from "@/lib/appPaths";
import type { ForgotPasswordErrorAlertProps } from "./ForgotPasswordErrorAlert.types";

const FORGOT_STATES = {
  DEFAULT: "default",
  EMAIL_NOT_FOUND: "email_not_found",
  ACCOUNT_BLOCKED: "account_blocked",
  NOT_ACTIVATED: "not_activated",
} as const;

export const ForgotPasswordErrorAlert: React.FC<
  ForgotPasswordErrorAlertProps
> = ({ state }) => {
  switch (state) {
    case FORGOT_STATES.EMAIL_NOT_FOUND:
      return (
        <StatusAlert
          variant="error"
          title="Email not found"
          message="No admin account found with this email address. Please check and try again."
        />
      );
    case FORGOT_STATES.ACCOUNT_BLOCKED:
      return (
        <StatusAlert
          variant="error"
          title="Account Blocked"
          message="This admin account is blocked. Please contact support for assistance."
          action={
            <a
              href="mailto:support@smartstore.com"
              className="text-sm font-medium text-rose-700 dark:text-rose-300 hover:underline"
            >
              Contact Support
            </a>
          }
        />
      );
    case FORGOT_STATES.NOT_ACTIVATED:
      return (
        <StatusAlert
          variant="warning"
          title="Account Not Activated"
          message="Please accept your invitation to activate your account before resetting your password."
          action={
            <a
              href={withAppBase("/invite/accept")}
              className="text-sm font-medium text-amber-700 dark:text-amber-300 hover:underline"
            >
              Accept Invitation
            </a>
          }
        />
      );
    default:
      return null;
  }
};
